import { Button, Modal } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import type { Organization, OrganizationMember } from '@hotjar/organization';

import { TRANSLATION_DOMAIN } from '../constants';

interface Props {
  isOpen: boolean;
  isDeleting: boolean;
  organization: Organization;
  user: OrganizationMember;
  onCancel: () => unknown;
  onConfirm: (organization: Organization, user: OrganizationMember) => unknown;
}

export function RevokeUserAccessModal({
  isOpen,
  isDeleting,
  organization,
  user,
  onCancel,
  onConfirm,
}: Props): JSX.Element {
  const { t } = useTranslationWithPrefix(`${TRANSLATION_DOMAIN}.remove-user`);

  return (
    <Modal appElementSelector="#root" contentLabel={t('title')} isOpen={isOpen} onClose={onCancel}>
      <Modal.Header title={t('title')} />
      <Modal.Body>
        {t('description', {
          userName: user.name,
        })}
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" isDisabled={isDeleting} onClick={onCancel}>
          {t('cancel')}
        </Button>
        <Button kind="danger" isLoading={isDeleting} onClick={() => onConfirm(organization, user)}>
          {t('confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
